import React, {Component} from "react";
import {toast} from "react-toastify";
import ApiConnect from "../../../../Utils/ApiConnect";
import AutoComplete from "../../../Components/AutoComplete";

export default class DispatchEmployee extends Component {
  constructor(props) {
    super(props);
    this.state = {
      EmployeeList: false,
      bookingId: props.BookingDetails.id,
      deliveryAgent: "",
      btnDisable: false,
      formError: false,
    };
  }

  componentDidMount() {
    this.fetchAllEmployee();
  }
  fetchAllEmployee() {
    ApiConnect.get("/Module/Utilities/Employee/AllEmployee").then(
      (response) => {
        this.setState({ EmployeeList: response.data });
      }
    );
  }
  handleChange = (key, name, id) => {
    this.setState({ deliveryAgent: id });
  };
  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ btnDisable: true });
    var Fdata = new FormData();
    Fdata.append("booking", this.state.bookingId);
    Fdata.append("agent", this.state.deliveryAgent);
    ApiConnect({
      method: "post",
      url: "/Module/Booking/Main/AssignDelivery",
      data: Fdata,
    })
      .then((response) => {
        this.setState({ btnDisable: false, formError: false });
        if (response.data.status === 201) {
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
          this.props.trigger();
        } else {
          this.setState({ formError: response.data.message });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  render() {
    return (
      <div className="card-body">
        <form onSubmit={(e) => this.handleSubmit(e)}>
          <div className="form-group">
            <label>Employee</label>
            {this.state.EmployeeList ? (
              <AutoComplete
                name="employee"
                action={this.handleChange}
                placeHolder="Employee Name"
                styleName=""
                items={this.state.EmployeeList}
              />
            ) : (
              ""
            )}
          </div>
          <footer className="card-footer text-right">
            <button
              className="btn btn-primary w-100"
              type="submit"
              disabled={this.state.btnDisable}
            >
              Assign Employee
            </button>
          </footer>
        </form>
      </div>
    );
  }
}
